import { useContext, useState, useEffect } from "react";
//components
import { Modal, TextField, Box, Button } from "@material-ui/core";
import { ModalHeader } from "./ModalHeader";
//Contexts
import { UserContext } from "../Contexts/UserContext";
//Sounds
// import tick from '../sounds/Tick.m4a'
// import AirplaneDing from '../sounds/AirplaneDing.m4a'
// import SlideWhistle from '../sounds/SlideWhistle.m4a'
// import Badoo from '../sounds/Badoo.m4a'
// import PoliceSiren from '../sounds/PoliceSiren.m4a'
// import warning from '../sounds/warning.ogg'
//Styles
import { makeStyles } from "@material-ui/core/styles";
import { useToggle } from "../CustomHooks/useToggle";
//Utils
// import { useCookies } from 'react-cookie'
// import { useLocalStorage } from '../utils/utils';

const useStyles = makeStyles(theme => ({
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    display: "flex",
    flexDirection: "column",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    maxWidth: "50%",
    margin: "auto",
  },
  margin: {
    margin: "30px",
    width: "300px",
  },
  container: {
    width: "fit-content",
    maxWidth: "75vw",
    flexGrow: 1,
    backgroundColor: "white",
    height: "fit-content",
    maxHeight: "75vh",
    overflow: "auto",
  },
  vertFlex: {
    display: "flex",
    flexDirection: "column",
  },
}));

const CustomDropdown = ({
  name,
  label,
  value,
  onChange,
  helperText,
  options = [
    { value: true, label: "On" },
    { value: false, label: "Off" },
  ],
}) => {
  const classes = useStyles();

  return (
    <TextField
      id={name + "-select"}
      name={name}
      inputProps={{ "data-cy": name + "-input" }}
      className={classes.margin}
      select
      label={label}
      value={value}
      onChange={onChange}
      SelectProps={{
        native: true,
      }}
      helperText={helperText}
      variant="outlined"
    >
      {options.map(option => {
        return (
          <option key={option.label} value={option.value}>
            {option.label}
          </option>
        );
      })}
    </TextField>
  );
};
// const SoundDropDown = ({ name, label, value, onChange, helperText,
//   options = [
//     { value: "false", label: "Off" },
//     { value: "tick", label: "Tick" },
//     { value: "Badoo", label: "Badoo" },
//     { value: "warning", label: "Warning" },
//     { value: "AirplaneDing", label: "Airplane Ding" },
//     { value: "SlideWhistle", label: "Slide Whistle" },
//     { value: "PoliceSiren", label: "Police Siren" },
//   ]
// }) => {
//   const classes = useStyles();

//   return (
//     <TextField
//       id={name + "-select"}
//       name={name}
//       inputProps={{ "data-cy": name + "-input" }}
//       className={classes.margin}
//       select
//       label={label}
//       value={value}
//       onChange={onChange}
//       SelectProps={{
//         native: "false",
//       }}
//       helperText={helperText}
//       variant="outlined"
//     >
//       {options.map(option => {
//         return <option key={option.label} value={option.value}>{option.label}</option>
//       })}
//     </TextField>
//   )
// }

const Preferences = ({
  showPreferences,
  closePreferences,
  userPreferences,
  setUserPreferences,
}) => {
  const classes = useStyles();
  const { nightMode } = useContext(UserContext);
  // const [testPreferences, setTestPreferences] = useLocalStorage("testPreferences", {})

  const handleChange = e => {
    const { name, value } = e.target || {};
    setUserPreferences(prevState => {
      return { ...prevState, [name]: value };
    });
  };
  // const handleTestChange = (e) => {
  //   setTestPreferences(prevState => {
  //     return { ...prevState, [e.target.name]: e.target.value }
  //   })
  // }

  // const sendMutation = (e) => {
  //   e.preventDefault()
  //   closePreferences()
  // }

  // const sampleSound = (e) => {
  //   setUserPreferences(prevState => {
  //     return { ...prevState, [e.target.name]: e.target.value }
  //   })
  //   switch (e.target.value) {

  //     case "tick":
  //       new Audio(tick).play()
  //       return null;

  //     case "warning":
  //       new Audio(warning).play()

  //       return null;

  //     case "AirplaneDing":
  //       new Audio(AirplaneDing).play()

  //       return null;

  //     case "SlideWhistle":
  //       new Audio(SlideWhistle).play()

  //       return null;
  //     case "Badoo":
  //       new Audio(Badoo).play()

  //       return null;
  //     case "PoliceSiren":
  //       new Audio(PoliceSiren).play()

  //       return null;

  //     default:
  //       return null;
  //   }
  // }

  // if (isNotSelf && toks[1] === "call_info_header" && soundEnabled === "false") {
  //   console.log('audio disabled')
  // }
  // else if (isNotSelf && toks[1] === "call_info_header") {
  //   console.log('sound enabled')
  //   new Audio(soundSelected==="tick" ? tick : warning).play()
  // }

  // const toggleNightMode = (event) => {
  //   setNightMode(event.target.value)
  //   setCookie(`mp-userId-${userId}-night-mode`, event.target.value)
  // }

  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={showPreferences}
      onClose={closePreferences}
      className={classes.modal}
      data-cy="preferences-modal"
    >
      <div
        className={classes.container}
        style={{ backgroundColor: nightMode ? "black" : "white" }}
      >
        <ModalHeader nightMode={nightMode} headerName={"User Settings"} />

        {/* <h3>This is only a mock up. Changing these setting will have no effect on the application.</h3> */}
        {/* <TextField
          id="night-mode-select"
          name="night"
          inputProps={{ "data-cy": "night-mode-input" }}
          className={classes.padding}
          select
          label="Night mode"
          value={nightMode}
          onChange={toggleNightMode}
          SelectProps={{
            native: true,
          }}
          helperText="Turn night mode on or off"
          variant="outlined"
        >
          <option value={false}>Off</option>
          <option value={true}>On</option>
        </TextField> */}
        <div className={classes.vertFlex}>
          <StorageUsage />
          <CustomDropdown
            name={"stickyTabs"}
            label={"Sticky Tabs"}
            value={userPreferences?.stickyTabs || false}
            onChange={handleChange}
            helperText={
              "Keep the tabs at the top of the screen when scrolling down in an incident"
            }
          />
          <CustomDropdown
            name={"stickyHeader"}
            label={"Sticky Header"}
            value={userPreferences?.stickyHeader || false}
            onChange={handleChange}
            helperText={
              "Keep the header at the top of the screen when scrolling down in an incident"
            }
          />
          <CustomDropdown
            name={"oriColor"}
            label={"Use Separate ORI Colors"}
            value={userPreferences?.oriColor || false}
            onChange={handleChange}
            helperText={
              "Use different colors for each ORI in the Active Incident and Available Officer table"
            }
          />
          {/* <div style={{ alignItems: 'center', fontSize: '1rem', fontWeight: 'bold', textAlign: 'center', width: '100%', color: nightMode ? 'white' : 'black' }}>Alerts</div>
          <SoundDropDown
            name={"incidentUpdateSound"}
            label={"Initial Call Frame Updates"}
            value={userPreferences?.incidentUpdateSound || false}
            // onClose={handleChange}
            onChange={sampleSound}
            helperText={"Enable Sound Alerts for Initial Call Frame Updates"}
          /> */}
          {/* <CustomDropdown
            name={"disableConnectivityPolling"}
            label={"Disable Connectivity Polling"}
            value={userPreferences?.disableConnectivityPolling || false}
            onChange={handleChange}
            helperText={"Disabling connectivity polling may improve online performance but may negatively impact offline detection. PLEASE REFRESH AFTER CHANGING THIS SETTING."}
          /> */}
          {/* <div style={{display: 'flex', flexDirection: 'column', justifyContent: "center", alignItems: "center"}}>
            <label>Connectivity Timeout (ms)</label>
            <input
              type="number"
              value={testPreferences?.connectivityTimeout}
              onChange={handleTestChange}
              name="connectivityTimeout"
            />
          </div>
          <div style={{display: 'flex', flexDirection: 'column', justifyContent: "center", alignItems: "center"}}>
            <label>GraphQL Timeout (ms)</label>
            <input
              type="number"
              value={testPreferences?.graphQlTimeout}
              onChange={handleTestChange}
              name="graphQlTimeout"
            />
          </div>
          <div style={{display: 'flex', flexDirection: 'column', justifyContent: "center", alignItems: "center"}}>
            <label>Connectivity Polling Interval (ms)</label>
            <input
              type="number"
              value={testPreferences?.connectivityPollingInterval}
              onChange={handleTestChange}
              name="connectivityPollingInterval"
            />
          </div> */}
        </div>
        {/* <TextField
          id="ori-display-select"
          select
          name="display"
          inputProps={{ "data-cy": "oris-displayed-input" }}
          className={classes.padding}
          label="ORIs Displayed"
          value={prefValues.display}
          onChange={handleChange}
          SelectProps={{
            native: true,
          }}
          helperText="Please select which ORIs should be displayed on your dashboard"
          variant="outlined"
        >
          <option value="1">Show all dispatched ORIs</option>
          <option value="2">Show Only Dispatched PD ORIs</option>
          <option value="3">Show Selected ORIs Only</option>
          <option value="4">Select Among All ORIs</option>
        </TextField>
        */}
        {/* <TextField
          id="ori-color-select"
          select
          name="oneColor"
          inputProps={{ "data-cy": "use-one-color-input" }}
          className={classes.padding}
          label="Use One Color For Non PD ORIs"
          value={prefValues.oneColor}
          onChange={handleChange}
          SelectProps={{
            native: true,
          }}
          helperText="If true, all ORIs will display as the same color."
          variant="outlined"
        >
          <option value="1">True</option>
          <option value="2">False</option>
        </TextField>
        <TextField
          id="remember-ori-selections-select"
          select
          name="remember"
          inputProps={{ "data-cy": "remember-ori-input" }}
          className={classes.padding}
          label="Remember New Incident ORI Selections"
          value={prefValues.remember}
          onChange={handleChange}
          SelectProps={{
            native: true,
          }}
          helperText="Setting this to true will use the last ORI selected for a new incident instead of defaulting to your home ORI."
          variant="outlined"
        >
          <option value="1">True</option>
          <option value="2">False</option>
        </TextField> */}
        <Box display="flex" flexDirection="row" justifyContent="space-around">
          {/* <Button data-cy='preferences-submit-button' variant="contained" type="submit">Submit</Button> */}
          <Button
            data-cy="preferences-cancel-button"
            variant="contained"
            className={classes.margin}
            onClick={closePreferences}
          >
            Close
          </Button>
        </Box>
      </div>
    </Modal>
  );
};

const StorageUsage = () => {
  const [storage, setStorage] = useState({ usage: 0, quota: 0 });
  const [showSizes, toggleShowSizes] = useToggle(false);

  useEffect(() => {
    if (navigator.storage && navigator.storage.estimate) {
      navigator.storage
        .estimate()
        .then(({ usage, quota }) => {
          setStorage({ usage, quota });
        })
        .catch(error => {
          console.error(error);
        });
    } else {
      console.warn("StorageManager API is not supported in this browser.");
    }
  }, []);

  const convertToMB = bytes => {
    return (bytes / 1024 / 1024).toFixed(2);
  };

  const convertToGB = bytes => {
    return (bytes / 1024 / 1024 / 1024).toFixed(2);
  };

  const usageInMB = convertToMB(storage?.usage);
  const quotaInMB = convertToMB(storage?.quota);

  let usageDisplay = `${usageInMB} MB`;
  let quotaDisplay = `${quotaInMB} MB`;

  if (usageInMB >= 1000) {
    usageDisplay = `${convertToGB(storage?.usage)} GB`;
  }

  if (quotaInMB >= 1000) {
    quotaDisplay = `${convertToGB(storage?.quota)} GB`;
  }

  if (!navigator.storage || !navigator.storage.estimate) {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        StorageManager API is not supported in this browser.
      </div>
    );
  } else if (storage?.quota !== 0) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          Storage Usage: {usageDisplay} of {quotaDisplay}
        </div>
        <button onClick={toggleShowSizes}>
          {showSizes ? "Hide" : "Show"} Local Storage
        </button>
        {showSizes && <LocalStorageSizes />}
      </div>
    );
  } else {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        Your quota is 0.
      </div>
    );
  }
};

const LocalStorageSizes = () => {
  function getLocalStorageSizes() {
    const sizes = [];
    let totalSize = 0;
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      const compressedItem = localStorage.getItem(key);
      // let item = localGetData(key)?.toString();
      const size = (((compressedItem?.length || 0) + key?.length) * 2) / 1024; // size in kB
      sizes.push({ key, size });
      totalSize += size;
    }
    //sort by size
    sizes.sort((a, b) => b.size - a.size);
    return { sizes, totalSize };
  }
  const { sizes, totalSize } = getLocalStorageSizes();

  return (
    <div style={{ padding: "5px" }}>
      <h3>Local Storage</h3>
      <div>Total size: {totalSize.toFixed(2)} kB</div>
      <ul>
        {sizes.map(({ key, size }) => (
          <li key={key}>
            {key}: {size.toFixed(2)} kB
          </li>
        ))}
      </ul>
    </div>
  );
};
export default Preferences;
